"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoldSuggestionModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var SuggestionModal_1 = require("../../../../components/modals/SuggestionModal");
var modals = require("../tierTable/TierTableInfoModalRenderers");
var journey_services_1 = require("@athena-portal/journey-services");
var commonFunctions_1 = require("../../../../commonFunctions");
var services_1 = require("@falcon/services");
var GoldSuggestionModal = /** @class */ (function (_super) {
    __extends(GoldSuggestionModal, _super);
    function GoldSuggestionModal(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isSuggestionModalOpen: false
        };
        _this.toggleSuggestionModal = _this.toggleSuggestionModal.bind(_this);
        return _this;
    }
    GoldSuggestionModal.prototype.componentDidMount = function () {
        this.setState({
            isSuggestionModalOpen: true
        });
    };
    GoldSuggestionModal.prototype.render = function () {
        var modalTitle = "Because of the changes you've made...";
        var goldTierEligible = (0, commonFunctions_1.isTierNotDeclined)(services_1.GOLD_TIER, this.props.interaction.tieredUnderwritingResult);
        if (goldTierEligible) {
            return ((0, jsx_runtime_1.jsx)(SuggestionModal_1.SuggestionModal, { title: modalTitle, isSuggestionModalOpen: this.state.isSuggestionModalOpen, toggleSuggestionModal: this.toggleSuggestionModal, children: modals.renderFlowPremierSuggestionModal(this.props.interaction.coverLevel) }));
        }
        else {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
    };
    GoldSuggestionModal.prototype.toggleSuggestionModal = function () {
        this.setState({
            isSuggestionModalOpen: !this.state.isSuggestionModalOpen
        });
        journey_services_1.ObjectManipulator.setField("uistate.showGoldSuggestionModal", this.props.interaction, false);
    };
    return GoldSuggestionModal;
}(plugin_journey_1.WidgetBase));
exports.GoldSuggestionModal = GoldSuggestionModal;
//# sourceMappingURL=GoldSuggestionModal.js.map